import { ReactNode } from 'react';
import {
  BenefitInfoTextExtensionInterface,
  BenefitInfoTextProps,
  BenefitLinkProps,
  BenefitSpecialLinkProps,
} from '../../../../extension/interface/benefit-info-text.extension.interface';

export class LunchBenefitInfoTextExtension extends BenefitInfoTextExtensionInterface {
  getBenefitLinks(): BenefitLinkProps | undefined {
    return {
      managerSpecific: 'https://www.youtube.com/watch?v=xoOR_gCUxYo',
      appSpecific: 'https://www.youtube.com/watch?v=YNFu_KdWVFg',
    };
  }

  getBenefitMoreLinks(): BenefitSpecialLinkProps | undefined {
    return undefined;
  }

  getHelpCenterLink(): string | undefined {
    return 'https://support.probonio.de/hc/de/sections/21154621463058--Essenszuschuss-Stand-2024';
  }

  renderAdditionalContent(_props: BenefitInfoTextProps): ReactNode {
    return null;
  }
}
